export default __webpack_public_path__ + "static/media/GITHUB_ico.2fa46065.svg";